<template>
	<div>
		<div class="skeleton-block" :style="{ width: width, height: height, borderRadius: borderRadius }" />
	</div>
</template>

<script>
export default {
	name: 'SkeletonBlock',
	props: {
		width: {
			type: String,
			default: '100%'
		},
		height: {
			type: String,
			default: '100%'
		},
		borderRadius: {
			type: String,
			default: '8px'
		}
	},
}
</script>

<style lang="scss" scoped>
.skeleton-block {
	background-color: #E2E8FF;
	position: relative;
	overflow: hidden;
	
	&::after {
		content: '';
		position: absolute;
		inset: 0;
		transform: translateX(-100%);
		background: linear-gradient(
			90deg,
			transparent,
			rgba(255, 255, 255, 0.6),
			transparent
		);
		animation: shimmer 1.4s infinite;
	}

	@keyframes shimmer {
		100% {
			transform: translateX(100%);
		}
	}
}
</style>